import(/* webpackMode: "eager" */ "/var/www/html/tvfoco-headless/src/app/global-error.js");
